import * as Joi from 'joi';
import { getEmailSchema } from '../../utils/JoiUtils';

const editOpsAdminSchema = Joi.object({
  email: getEmailSchema('Email'),
  roles: Joi.array()
    .items(
      Joi.object({
        id: Joi.number(),
        displayName: Joi.string(),
      })
    )
    .has(Joi.object({ id: Joi.number(), displayName: Joi.string() }))
    .messages({
      'array.hasUnknown': 'Please select at least one User Group',
    }),
  approver: Joi.boolean(),
});

export default editOpsAdminSchema;
